var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MarketplaceDepositType, } from '@spike/marketplace-model';
import { createEmptyAddress, createEmptyWeek, } from '@spike/model';
import _ from 'lodash';
import moment from 'moment-timezone';
import { v4 as uuid } from 'uuid';
export var convertMarketplace = function (marketplaceDto, masterData) {
    var _a;
    return {
        id: marketplaceDto.id,
        premium: (_a = marketplaceDto.premium) !== null && _a !== void 0 ? _a : false,
        basics: convertBasics(marketplaceDto, masterData),
        additionalInfo: convertAdditionalInfo(marketplaceDto),
        schedule: convertSchedule(marketplaceDto),
        logos: convertLogos(marketplaceDto),
        requirements: convertRequirements(marketplaceDto, masterData),
        petTypes: convertPetTypes(marketplaceDto, masterData),
        deposit: {
            value: marketplaceDto.deposit_value,
            type: marketplaceDto.deposit_category || MarketplaceDepositType.None,
        },
        taxes: convertTaxes(marketplaceDto),
        tips: convertTips(marketplaceDto),
        staffTraining: convertStaffTraining(marketplaceDto, masterData),
        grooming: convertGrooming(marketplaceDto, masterData),
        marketingInfo: convertMarketingInfo(marketplaceDto),
        legacy: convertLegacy(marketplaceDto),
        businessAreas: marketplaceDto.business_area_list.map(function (baId) { return masterData.businessAreas.find(function (businessArea) { return businessArea.id === baId; }); }),
        isDental: marketplaceDto.business_area_list.map(function (ba) { return ba.toLocaleLowerCase(); }).includes('dental'),
        isGrooming: marketplaceDto.business_area_list.map(function (ba) { return ba.toLocaleLowerCase(); }).includes('grooming'),
        notifications: {
            newBookings: marketplaceDto.optin_email_new_bookings,
            appointmentCancellations: marketplaceDto.optin_email_cancellations,
            client: marketplaceDto.online_booking,
            emailContent: marketplaceDto.email_content ? marketplaceDto.email_content.split('\n') : [],
            settings: convertNotificationSettings(marketplaceDto)
        },
        integrations: {
            googleAnalyticsTrackingId: marketplaceDto.ga_tracking_id,
        },
        onlineBooking: convertOnlineBooking(marketplaceDto, masterData),
        onboardingStep: marketplaceDto.onboarding_step || 1,
        paymentsEnabled: marketplaceDto.payment_enabled,
        twilioPhoneNumber: marketplaceDto.twilio_phone_number,
        active: marketplaceDto.active,
        intakeForm: {
            enabled: marketplaceDto.intake_form,
            questionsEnabled: marketplaceDto.custom_questions_enabled,
            questions: marketplaceDto.custom_questions.map(function (question) {
                var _a, _b;
                return ({
                    uuid: uuid(),
                    id: question.id,
                    marketplaceId: question.marketplace_id,
                    order: question.display_order,
                    question: question.question_text,
                    enabled: question.enabled,
                    required: question.required,
                    category: question.category,
                    createdAt: moment(question.created_at).tz((_a = marketplaceDto.calendars[0]) === null || _a === void 0 ? void 0 : _a.time_zone),
                    updatedAt: moment(question.updated_at).tz((_b = marketplaceDto.calendars[0]) === null || _b === void 0 ? void 0 : _b.time_zone),
                });
            }),
        },
        scheduleType: marketplaceDto.schedule_type,
        petPositivePersonality: marketplaceDto.custom_pet_positive_personality_list,
        petNegativePersonality: marketplaceDto.custom_pet_negative_personality_list,
    };
};
var convertOnlineBooking = function (marketplaceDto, masterData) {
    var _a, _b;
    return ({
        active: marketplaceDto.olb_enabled,
        slug: marketplaceDto.url_slug,
        from: (_a = masterData.olbFromLimits.find(function (limit) { return limit.id === marketplaceDto.olb_minimum_lead_time; })) !== null && _a !== void 0 ? _a : null,
        to: (_b = masterData.olbToLimits.find(function (limit) { return limit.id === marketplaceDto.olb_maximum_lead_time; })) !== null && _b !== void 0 ? _b : null,
        allowClientsSelectStaff: marketplaceDto.olb_can_select_staff,
        allowNewClients: marketplaceDto.olb_accept_new_client,
        bookingRequestsEnabled: marketplaceDto.olb_booking_request,
        pricingOption: marketplaceDto.pricing_option,
    });
};
var convertBasics = function (marketplaceDto, masterData) {
    return {
        businessName: marketplaceDto.business_name || '',
        email: marketplaceDto.email || '',
        phone: marketplaceDto.phone || '',
        website: marketplaceDto.website || '',
        address: convertAddress(marketplaceDto, masterData),
    };
};
var convertAddress = function (marketplaceDto, masterData) {
    var addressDto = marketplaceDto.addresses.filter(function (a) { return a.active; })[0];
    if (addressDto) {
        return {
            id: addressDto.id,
            street: addressDto.address_line_one || '',
            suite: addressDto.address_line_two,
            city: addressDto.city || '',
            state: addressDto.state || '',
            zipcode: addressDto.zipcode || '',
            country: masterData.countries.find(function (country) { return country.id.toUpperCase() === addressDto.country.toUpperCase(); }),
        };
    }
    else {
        return createEmptyAddress();
    }
};
var convertAdditionalInfo = function (marketplaceDto) {
    return {
        yearsInBusiness: marketplaceDto.years_in_business,
        numberOfEmployees: marketplaceDto.employees,
        mobileBusiness: marketplaceDto.mobile_business,
        localBusiness: marketplaceDto.local_business,
        atHomeBusiness: marketplaceDto.athome_business,
        inHomeBusiness: marketplaceDto.inhome_business,
        taxRate: marketplaceDto.tax_rate,
    };
};
var convertSchedule = function (marketplaceDto) {
    var calendarDto = marketplaceDto.calendars.filter(function (c) { return c.active; })[0];
    if (calendarDto) {
        return {
            id: calendarDto.id,
            timeZone: calendarDto.time_zone,
            week: _.merge(createEmptyWeek(), JSON.parse(calendarDto.range)),
            specialHours: marketplaceDto.special_hours.map(function (sh) { return convertSpecialHour(sh); }),
        };
    }
    else {
        return {
            timeZone: '',
            week: createEmptyWeek(),
            specialHours: marketplaceDto.special_hours.map(function (sh) { return convertSpecialHour(sh); }),
        };
    }
};
var convertSpecialHour = function (specialHourDto) {
    return {
        id: specialHourDto.id,
        uuid: specialHourDto.id.toString(),
        name: specialHourDto.name,
        date: specialHourDto.date,
        isClosed: specialHourDto.closed,
        businessHours: specialHourDto.business_hours ? JSON.parse(specialHourDto.business_hours) : null,
    };
};
var convertLogos = function (marketplaceDto) {
    return {
        logoUrl: marketplaceDto.logo_url,
        promoImageUrl: marketplaceDto.promo_image_url,
        promoImageSecondaryUrl: marketplaceDto.promo_image_secondary_url,
        imageUrl: marketplaceDto.image_url,
    };
};
var convertRequirements = function (marketplaceDto, masterData) {
    var spayAndNeuter = 'spay_and_neuter';
    var proofOfVaccinations = 'proof_of_vaccinations';
    var discard = [spayAndNeuter, proofOfVaccinations];
    var filteredRequirements = marketplaceDto.pet_requirement_list.filter(function (id) { return !discard.includes(id); });
    return {
        spayedAndNeureted: marketplaceDto.pet_requirement_list.some(function (r) { return r === spayAndNeuter; }),
        requirements: marketplaceDto.pet_requirement_list
            .filter(function (id) { return masterData.petRequirements.some(function (r) { return r.id === id; }); })
            .filter(function (id) { return id !== spayAndNeuter; })
            .map(function (id) { return masterData.petRequirements.find(function (r) { return r.id === id; }); }),
        otherRequirements: filteredRequirements
            .filter(function (id) { return !masterData.petRequirements.some(function (r) { return r.id === id; }); })
            .map(function (other) { return _.capitalize(other); }),
    };
};
var convertToOrderedOption = function (dto, index, masterDataList) {
    var _a, _b;
    return {
        element: __assign({}, dto),
        order: (_b = (_a = masterDataList.find(function (master) { return master.element.id === dto.id; })) === null || _a === void 0 ? void 0 : _a.order) !== null && _b !== void 0 ? _b : index + 1,
    };
};
var convertToOrderedPetSize = function (dto, index, masterDataList) {
    var _a, _b, _c;
    return {
        element: { id: dto.id,
            name: dto.name,
            description: (_a = dto.description) !== null && _a !== void 0 ? _a : '',
            minWeight: dto.minWeight !== null && dto.minWeight !== undefined ? dto.minWeight : null,
            maxWeight: dto.maxWeight !== null && dto.maxWeight !== undefined ? dto.maxWeight : null },
        order: (_c = (_b = masterDataList.find(function (master) { return master.element.id === dto.id; })) === null || _b === void 0 ? void 0 : _b.order) !== null && _c !== void 0 ? _c : index + 1,
    };
};
var sortOrderedOptions = function (option, otherOption) {
    return option.order - otherOption.order;
};
var convertPetTypes = function (marketplaceDto, masterData) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var dogsType = marketplaceDto.dogs_detail ? JSON.parse(marketplaceDto.dogs_detail) : undefined;
    var catsType = marketplaceDto.cats_detail ? JSON.parse(marketplaceDto.cats_detail) : undefined;
    var exoticsType = marketplaceDto.exotics_detail ? JSON.parse(marketplaceDto.exotics_detail) : undefined;
    //Retrocompatibility to marketplaces that do not have set the cats sizes.
    if (catsType && (catsType.sizes === undefined || catsType.sizes.length === 0)) {
        catsType.sizes = masterData.petSizes.map(function (s) { return s.element; }).filter(function (s) { return s.id === 'small'; });
    }
    //Retrocompatibility to marketplaces that do not have set the cats sizes.
    if (exoticsType && (exoticsType.sizes === undefined || exoticsType.sizes.length === 0)) {
        exoticsType.sizes = masterData.petSizes.map(function (s) { return s.element; }).filter(function (s) { return s.id === 'medium'; });
    }
    return {
        dogs: {
            enabled: dogsType === undefined ? false : (_a = dogsType.enabled) !== null && _a !== void 0 ? _a : true,
            ages: (_b = dogsType === null || dogsType === void 0 ? void 0 : dogsType.ages) !== null && _b !== void 0 ? _b : [],
            sizes: ((_c = dogsType === null || dogsType === void 0 ? void 0 : dogsType.sizes) !== null && _c !== void 0 ? _c : []).map(function (size, index) { return convertToOrderedPetSize(size, index, masterData.petSizes); }).sort(sortOrderedOptions),
            hairTypes: ((_d = dogsType === null || dogsType === void 0 ? void 0 : dogsType.hairTypes) !== null && _d !== void 0 ? _d : []).map(function (option, index) { return convertToOrderedOption(option, index, masterData.dogHairTypes); }).sort(sortOrderedOptions),
            hairLengths: ((_e = dogsType === null || dogsType === void 0 ? void 0 : dogsType.hairLengths) !== null && _e !== void 0 ? _e : []).map(function (option, index) { return convertToOrderedOption(option, index, masterData.dogHairTypes); }).sort(sortOrderedOptions),
        },
        cats: {
            enabled: catsType === undefined ? false : (_f = catsType.enabled) !== null && _f !== void 0 ? _f : true,
            ages: (_g = catsType === null || catsType === void 0 ? void 0 : catsType.ages) !== null && _g !== void 0 ? _g : [],
            sizes: ((_h = catsType === null || catsType === void 0 ? void 0 : catsType.sizes) !== null && _h !== void 0 ? _h : []).map(function (size, index) { return convertToOrderedPetSize(size, index, masterData.petSizes); }).sort(sortOrderedOptions),
            hairTypes: ((_j = catsType === null || catsType === void 0 ? void 0 : catsType.hairTypes) !== null && _j !== void 0 ? _j : []).map(function (option, index) { return convertToOrderedOption(option, index, masterData.catHairTypes); }).sort(sortOrderedOptions),
            hairLengths: ((_k = catsType === null || catsType === void 0 ? void 0 : catsType.hairLengths) !== null && _k !== void 0 ? _k : []).map(function (option, index) { return convertToOrderedOption(option, index, masterData.catHairTypes); }).sort(sortOrderedOptions),
        },
        exotics: {
            enabled: exoticsType === undefined ? false : (_l = exoticsType.enabled) !== null && _l !== void 0 ? _l : true,
            types: (_m = exoticsType === null || exoticsType === void 0 ? void 0 : exoticsType.types) !== null && _m !== void 0 ? _m : [],
            others: (_o = exoticsType === null || exoticsType === void 0 ? void 0 : exoticsType.others) !== null && _o !== void 0 ? _o : [],
            sizes: ((_p = exoticsType === null || exoticsType === void 0 ? void 0 : exoticsType.sizes) !== null && _p !== void 0 ? _p : []).map(function (size, index) { return convertToOrderedPetSize(size, index, masterData.petSizes); }).sort(sortOrderedOptions),
        },
    };
};
var convertTaxes = function (marketplaceDto) {
    return marketplaceDto.taxes.length > 0
        ? marketplaceDto.taxes
            .sort(function (a, b) {
            return moment(a.created_at) > moment(b.created_at) ? 1 : moment(b.created_at) > moment(a.created_at) ? -1 : 0;
        })
            .map(function (tax) { return ({ id: tax.id, uuid: tax.uuid, name: tax.name, percentage: tax.value }); })
        : [];
};
var convertTips = function (marketplaceDto) {
    return !marketplaceDto.tip_rates || marketplaceDto.tip_rates.length === 0
        ? []
        : marketplaceDto.tip_rates.map(function (tip) { return ({ id: tip.id, uuid: tip.uuid, percentage: Math.floor(tip.value) }); });
};
var convertNotificationSettings = function (marketplaceDto) {
    return marketplaceDto.settings.map(function (setting) { return ({ id: setting.id, uuid: setting.uuid, active: (setting.value && setting.value !== 'f') ? true : false,
        description: setting.description, option: { id: setting.key, name: setting.name },
        reminderTime: Number(setting.value) ? { id: setting.value, name: "".concat(setting.value) } : undefined
    }); });
};
var convertStaffTraining = function (marketplaceDto, masterData) {
    var addressDto = marketplaceDto.addresses.filter(function (a) { return a.active; })[0];
    if (addressDto) {
        return {
            trainings: masterData.staff.training.filter(function (st) { return addressDto.staff_training_list.some(function (dto) { return dto === st.id; }); }),
            otherTrainings: addressDto.staff_training_list
                .filter(function (dto) { return !masterData.staff.training.some(function (st) { return st.id === dto; }); })
                .map(function (dto) { return _.capitalize(dto); }),
        };
    }
    else {
        return {
            trainings: [],
            otherTrainings: [],
        };
    }
};
var convertGrooming = function (marketplaceDto, masterData) {
    var addressDto = marketplaceDto.addresses.filter(function (a) { return a.active; })[0];
    if (addressDto) {
        return {
            holdingAreas: masterData.grooming.holdingAreas.filter(function (ha) { return addressDto.amenity_list.includes(ha.id); }),
            security: masterData.grooming.security.filter(function (s) { return addressDto.amenity_list.includes(s.id); }),
            sizeSeparation: masterData.grooming.sizeSeparation.filter(function (ss) { return addressDto.amenity_list.includes(ss.id); }),
            visibility: masterData.grooming.visibility.filter(function (v) { return addressDto.amenity_list.includes(v.id); }),
            others: addressDto.amenity_list
                .filter(function (a) {
                return !masterData.grooming.holdingAreas.some(function (ha) { return ha.id === a; }) &&
                    !masterData.grooming.security.some(function (s) { return s.id === a; }) &&
                    !masterData.grooming.sizeSeparation.some(function (ss) { return ss.id === a; }) &&
                    !masterData.grooming.visibility.some(function (v) { return v.id === a; });
            })
                .map(function (other) { return _.capitalize(other); }),
        };
    }
    else {
        return {
            holdingAreas: [],
            security: [],
            sizeSeparation: [],
            visibility: [],
            others: [],
        };
    }
};
var convertMarketingInfo = function (marketplaceDto) {
    return {
        locationsCount: marketplaceDto.locations_count,
    };
};
var convertLegacy = function (marketplaceDto) {
    return {
        petTypes: marketplaceDto.pet_list,
    };
};
